import BaseApiService from './api.base.service'
export default class RegistrationsApiService extends BaseApiService {
  constructor() {
    super('registrations')
  }

  registerUserBlogToEC(registrationData) {
    return this.callPost('/blog-users', registrationData)
  }

  getProfessions() {
    return this.callGet('/professions')
  }

  getRegistersByProfessionId(professionId) {
    return this.callGet(`/professions/${professionId}/registers`)
  }

  registerNewUser(registrationData) {
    return this.callPost('/', registrationData)
  }

  getMissingUserData() {
    return this.callGet('/info/missing')
  }

  addMissingUserData(missingUserData) {
    return this.callPost('/info/missing/save', missingUserData)
  }

  getProvinces() {
    return this.callGet('/provinces')
  }

  getMunicipalitiesByProvinceId(provinceId) {
    return this.callGet(`/provinces/${provinceId}/municipalities`)
  }

  getMissingClientDataFlags(journalActivationId) {
    return this.callPost(
      '/journal-activation/clients/info/missing',
      journalActivationId
    )
  }

  addMissingClientData(missingClientData) {
    return this.callPost(
      '/journal-activation/clients/info/missing/save',
      missingClientData
    )
  }

  checkUserExistenceByFiscalCode(fiscalCode) {
    return this.callGet(`/check/fiscalcode/${fiscalCode}`)
  }

  registerClientToECForJournalActivation(journalActivationId) {
    return this.callPost('/journal-activation/clients', journalActivationId)
  }
}

export const registrationsApi = new RegistrationsApiService()
